import React from 'react';
import { Box } from '@mui/material';
import { PlayArrow, Pause } from '@mui/icons-material';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { COLOR } from '@src/styles/color';
import CommonAvatar from './index';

const AudioAvatar = ({
  avatar,
  audioUrl,
  audioIconColor = COLOR.white,
  badgeIcon,
  size = 40,
  styleBadgeIcon,
  className,
  isHovered = false,
  onPlayAudio,
  onPauseAudio,
  isPlaying,
  active,
  frameImageUrl,
  ...rest
}) => (
  <Box sx={{ position: 'relative' }}>
    <CommonAvatar
      avatar={avatar}
      badgeIcon={badgeIcon}
      size={size}
      styleBadgeIcon={styleBadgeIcon}
      className={className}
      frameImageUrl={frameImageUrl}
      {...rest}
    />

    {/* Audio Play/Pause Overlay */}
    {(isHovered || isPlaying || active) && audioUrl && (
      <Box
        onClick={isPlaying ? onPauseAudio : onPlayAudio}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: COLOR.black[64],
          borderRadius: '50%',
          width: `${size}px`,
          height: `${size}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
          cursor: 'pointer',
        }}
      >
        {active && <DoneRoundedIcon sx={{ color: audioIconColor }} />}
        {!active && isPlaying ? (
          <Pause sx={{ color: audioIconColor }} />
        ) : (
          !active && <PlayArrow sx={{ color: audioIconColor }} />
        )}
      </Box>
    )}
  </Box>
);

export default AudioAvatar;
